var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.75C16.5 7.92425 16.4288 8.26289 15.6152 8.63752C14.7988 9.01346 13.5378 9.25 12 9.25C10.4622 9.25 9.20116 9.01346 8.38478 8.63752C7.57123 8.26289 7.5 7.92425 7.5 7.75C7.5 7.57575 7.57123 7.23711 8.38478 6.86248C9.20116 6.48654 10.4622 6.25 12 6.25C13.5378 6.25 14.7988 6.48654 15.6152 6.86248C16.4288 7.23711 16.5 7.57575 16.5 7.75ZM15.0523 10.4106C14.158 10.6369 13.1145 10.75 12 10.75C10.8855 10.75 9.84197 10.6369 8.94774 10.4106L10.9279 13.3148C11.1377 13.6226 11.25 13.9866 11.25 14.3591V17.7291C11.3097 17.7409 11.3912 17.75 11.5 17.75C11.9224 17.75 12.249 17.6093 12.4497 17.4336C12.6349 17.2716 12.75 17.0534 12.75 16.75V14.3591C12.75 13.9866 12.8623 13.6226 13.0721 13.3148L15.0523 10.4106ZM12 4.75C15.3137 4.75 18 5.75 18 7.75C18 8.40152 17.8037 9.03792 17.4367 9.57623L14.3115 14.1598C14.2714 14.2186 14.25 14.288 14.25 14.3591V16.75C14.25 18.25 13 19.25 11.5 19.25C10 19.25 9.75 18.25 9.75 18.25V14.3591C9.75 14.288 9.72858 14.2186 9.68852 14.1598L6.56334 9.57623C6.19631 9.03792 6 8.40152 6 7.75C6 5.75 8.68629 4.75 12 4.75ZM11.1202 17.6864C11.1105 17.6808 11.1069 17.6765 11.1069 17.6765C11.1069 17.6765 11.1122 17.6789 11.1202 17.6864Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#ACB2C3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1d35da21e329b794672938d0cd601bce.svg";
export { ForwardRef as ReactComponent };